var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropletw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 19.0164C10.7333 19.0164 12.8333 16.8814 12.8333 14.2914C12.8333 12.9381 12.1683 11.6548 10.8383 10.5698C9.50833 9.48477 8.505 7.87477 8.16667 6.18311C7.82833 7.87477 6.83667 9.49644 5.495 10.5698C4.15333 11.6431 3.5 12.9498 3.5 14.2914C3.5 16.8814 5.6 19.0164 8.16667 19.0164Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6533 7.7001C15.4557 6.41808 16.0245 5.00399 16.3333 3.52344C16.9166 6.4401 18.6666 9.2401 21 11.1068C23.3333 12.9734 24.5 15.1901 24.5 17.5234C24.5066 19.1361 24.0343 20.7145 23.1429 22.0584C22.2515 23.4023 20.9811 24.4513 19.4928 25.0723C18.0045 25.6934 16.3653 25.8586 14.783 25.5469C13.2007 25.2353 11.7466 24.4608 10.605 23.3218",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropletw);
export default __webpack_public_path__ + "static/media/dropletw.0ce8353ea8f86c74e0e949ce343fa507.svg";
export { ForwardRef as ReactComponent };